module.exports = __webpack_public_path__ + "img/pending.0529fe40.svg";